import { Divider, Flex, Layout, Menu, Typography } from 'antd';
import { TFunction } from 'i18next';
import { Fragment, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import LeftIcon from 'src/assets/icons/left.png';
import RightIcon from 'src/assets/icons/right.png';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { getLastItem, getPathsFromRoles } from 'src/utils/utils';
import Icon from '../Icon';
import './sidebar.scss';
const { Sider: SiderAntd } = Layout;
const { Text } = Typography;

type MenuItem = {
  label: React.ReactNode;
  key: React.Key;
  icon?: React.ReactNode;
  children?: MenuItem[];
  code?: string;
};

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  path?: string[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    path
  } as MenuItem;
}

const items = (t: TFunction<'translation', undefined, 'translation'>): MenuItem[] => {
  return [
    getItem(t(String(getLastItem(urlPath.itemMasterData.path))), urlPath.itemMasterData.location),
    getItem(t(String(getLastItem(urlPath.itemType.path))), urlPath.itemType.location),
    getItem(t(String(getLastItem(urlPath.itemGroup.path))), urlPath.itemGroup.location)
  ];
};

export default function ItemMasterDataSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState<string>(location.pathname);

  const { roles, isSidebarCollapsed, setIsSidebarCollapsed } = useContext(AppContext);

  const paths = useMemo(() => {
    return getPathsFromRoles(roles);
  }, [roles]);

  const handleCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  return (
    <SiderAntd
      trigger={null}
      width={'260px'}
      collapsible
      collapsed={isSidebarCollapsed}
      collapsedWidth={50}
      className='sidebar-main no-subheader'
    >
      {!isSidebarCollapsed ? (
        <Fragment>
          <Flex justify='space-between' align='center' gap={10}>
            <Text strong className='sidebar-title'>
              Quản lý mua hàng
            </Text>
            <div className='menu-button menu-button-open' onClick={handleCollapse}>
              <Icon url={LeftIcon} size={20} titleTooltip='Menu' />
            </div>
          </Flex>
          <Divider dashed className='sidebar-title-divider' />

          <Menu
            selectedKeys={[selectedKey]}
            mode='inline'
            items={Array.isArray(paths) ? items(t) : []}
            style={{ marginTop: 20, borderRight: 0, minHeight: 100 }}
            onClick={({ key }) => navigate(key)}
          />
        </Fragment>
      ) : (
        <Fragment>
          <Flex
            justify='flex-end'
            align='center'
            gap={10}
            className='menu-button menu-button-open'
            onClick={handleCollapse}
          >
            <Icon
              url={RightIcon}
              size={20}
              titleTooltip='Xem menu'
              arrowTooltip={false}
              placementTooltip='right'
              styleTooltip={{ fontSize: '12px' }}
            />
          </Flex>
        </Fragment>
      )}
    </SiderAntd>
  );
}
